import { DocumentationPageContentData } from "../dsm";
import { z } from "zod";
export const ForgeProjectArtifactContentData = DocumentationPageContentData;
export const ForgeProjectArtifactContent = z.object({
    id: z.string(),
    artifactId: z.string(),
    projectId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    data: ForgeProjectArtifactContentData,
});
